import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '../../components/layout/AppShell';
import { ROUTES } from '../../config/routes';
import { useAuthStore } from '../../stores/authStore';
import { useDepartmentsStore } from '../../stores/departmentsStore';
import { useUIStore } from '../../stores/uiStore';
import { defaultRouteForUser } from '../../utils/defaultRoute';
import { AuthGuard } from '../guards/AuthGuard';

const HomePage = React.lazy(() => import('../../features/home/HomePage').then(module => ({ default: module.HomePage })));
const LoginPage = React.lazy(() => import('../../features/auth/LoginPage').then(module => ({ default: module.LoginPage })));
const AdminDashboard = React.lazy(() => import('../../features/admin/AdminDashboard').then(module => ({ default: module.AdminDashboard })));
const DepartmentPage = React.lazy(() => import('../../features/departments/DepartmentPage').then(module => ({ default: module.DepartmentPage })));
const DepartmentsIndexPage = React.lazy(() => import('../../features/departments/DepartmentsIndexPage').then(module => ({ default: module.DepartmentsIndexPage })));
const DocumentPage = React.lazy(() => import('../../features/documents/DocumentPage').then(module => ({ default: module.DocumentPage })));
const ErrorPage = React.lazy(() => import('../../features/errors/ErrorPage').then(module => ({ default: module.ErrorPage })));
const PublicQrPage = React.lazy(() => import('../../features/qr/PublicQrPage').then(module => ({ default: module.PublicQrPage })));

const LoadingScreen = () => <div className="min-h-dvh navy-bg grid place-items-center"><div className="text-center"><img src="/assets/images/luxurious_gold_emblem_and_logo_design.png" alt="MASAR" className="w-24 h-24 object-contain mx-auto animate-pulse" /><p className="text-xs text-gold-200 mt-2">Babil Health Directorate — Pharmacy Department</p></div></div>;

const ScanPage: React.FC = () => {
  const { openScanner } = useUIStore();
  const { user } = useAuthStore();
  const { departments } = useDepartmentsStore();
  React.useEffect(() => { openScanner(); }, [openScanner]);
  return <Navigate to={defaultRouteForUser(user, departments)} replace />;
};

export const AppRouter: React.FC = () => <Suspense fallback={<LoadingScreen />}><Routes>
  <Route path={ROUTES.login} element={<LoginPage />} />
  <Route path={ROUTES.qrPattern} element={<PublicQrPage />} />
  <Route element={<AuthGuard><AppShell /></AuthGuard>}>
    <Route path={ROUTES.root} element={<Navigate to={defaultRouteForUser(useAuthStore.getState().user, useDepartmentsStore.getState().departments)} replace />} />
    <Route path={ROUTES.home} element={<HomePage />} />
    <Route path={ROUTES.admin} element={<AuthGuard permission="admin.view"><AdminDashboard /></AuthGuard>} />
    <Route path={ROUTES.departments} element={<DepartmentsIndexPage />} />
    <Route path={ROUTES.departmentPattern} element={<DepartmentPage />} />
    <Route path={ROUTES.documentPattern} element={<DocumentPage />} />
    <Route path={ROUTES.scan} element={<ScanPage />} />
  </Route>
  <Route path={ROUTES.unauthorized} element={<ErrorPage type="unauthorized" />} />
  <Route path={ROUTES.notFound} element={<ErrorPage type="404" />} />
  <Route path="*" element={<ErrorPage type="404" />} />
</Routes></Suspense>;
